/**
 * Route binding for `24-7-tier-blind-support-with-published-sla`.
 *
 * Wired into TanStack Router via `createRoute`; the central router.tsx is
 * root-owned and is NOT modified by this dispatch. When root wires this
 * feature it imports `SupportSlaRoute` from here.
 */

import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { SupportSlaPage } from "../features/24-7-tier-blind-support-with-published-sla/SupportSlaPage";

export const SupportSlaRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/24-7-tier-blind-support-with-published-sla",
	component: SupportSlaPage,
});

export default SupportSlaRoute;
